/**
 * Tablas wide de subtareas (TareaChildTasksList, tenant Blumar Calidad, muchas columnas).
 * Unidades MUI theme spacing: 1 = 8px (salvo fontSize en px).
 */
export const CHILD_TASKS_WIDE_TABLE_LAYOUT = {
  cellPaddingX: 0.3,
  cellPaddingY: 0.5,
  headerFontSize: 11,
  bodyFontSize: 12,
  headerLineHeight: 1.25,
  headerLetterSpacing: '.06em',
} as const;
